import React from "react";
import { Phone, ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BuiltToLast() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="4273" id="expert-bathroom-transformations" className="bg-background text-foreground relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-secondary/40 z-10 backdrop-blur-[2px]" />
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/luxury_bathroom_custom_tile.png)] bg-cover bg-center bg-no-repeat" role="img" aria-label="Luxury bathroom with custom tile shower and premium finishes" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        {}
        <div className="mb-6 flex justify-center">
          <Badge className="bg-secondary text-primary hover:bg-secondary/90 px-4 py-1.5 text-sm font-bold uppercase tracking-widest shadow-md border border-primary/10">
            <ShieldCheck className="mr-2 h-4 w-4 text-accent" />
            Licensed & Insured
          </Badge>
        </div>

        {}
        <h1 className="mb-8 flex flex-col items-center justify-center text-5xl font-serif font-bold tracking-tight sm:text-6xl md:text-7xl lg:text-[80px] leading-[1.1]">
          <span className="text-primary drop-shadow-sm">EXPERT BATHROOM</span>
          <span className="text-accent drop-shadow-sm mt-2 md:mt-0 md:ml-4">REMODELING</span>
        </h1>

        {}
        <p className="mx-auto mb-10 max-w-2xl text-lg font-sans font-medium text-primary/80 md:text-xl drop-shadow-sm">
          20+ Years of Craftsmanship. Serving Hudson, River Falls, Prescott, and Ellsworth with premium quality.
        </p>

        {}
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
          <Link to="/ContactPage">
            <Button size="lg" className="h-14 min-w-[240px] rounded-sm bg-primary text-primary-foreground text-lg font-bold shadow-xl transition-all hover:scale-105 hover:bg-primary/90">
              Request a Quote
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
          
          <Link to="tel:+15555555555">
            <Button variant="outline" size="lg" className="h-14 min-w-[240px] rounded-sm border-2 border-primary bg-transparent text-lg font-bold text-primary shadow-xl backdrop-blur-sm transition-all hover:bg-primary hover:text-primary-foreground hover:scale-105">
              <Phone className="ml-2 h-5 w-5" />
              Call Now
            </Button>
          </Link>
        </div>
      </div>
      
      {}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background to-transparent z-10" />
    </section>;
}